// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13783":"d1bce88b","50805":"186c5aef"}[chunkId] + ".chunk.css";
};